import { testimonials } from '@/mocks/data';

export default function UserReviews() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="relative bg-background-200/70 rounded-2xl p-8 md:p-14 flex flex-col lg:flex-row gap-10 lg:gap-14 overflow-hidden border border-white/10">
          <div className="absolute top-0 left-0 w-64 h-64 opacity-[0.03]">
            <i className="ri-chat-quote-line text-foreground-50 text-[200px]" />
          </div>

          <div className="relative lg:w-2/5 flex items-center">
            <div className="flex -space-x-4">
              {testimonials.map((t, i) => (
                <div
                  key={t.id}
                  className={`w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-background-400 flex items-center justify-center border-2 border-background-200/70 overflow-hidden ${
                    i === 1 ? 'z-10 -translate-y-4' : ''
                  }`}
                >
                  <span className="text-foreground-300 font-heading font-bold text-xl md:text-2xl">{t.avatar}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative lg:w-3/5">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-8">
              瓜友神评
            </h2>

            <div className="space-y-8">
              {testimonials.map((t) => (
                <div key={t.id} className="border-l-2 border-primary-500/40 pl-5">
                  <i className="ri-double-quotes-l text-primary-500/60 text-xl mb-2 block" />
                  <p className="text-foreground-300 text-sm md:text-base leading-relaxed italic">
                    {t.comment}
                  </p>
                  <p className="text-foreground-600 text-sm mt-3 not-italic">
                    &mdash; {t.name}
                  </p>
                </div>
              ))}
            </div>

            <a
              href="#"
              className="inline-flex items-center gap-2 mt-10 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              查看更多热评 <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}